var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from "vue-facing-decorator";
import { getCurrentInstance } from "vue";
let ConfirmVue = class ConfirmVue extends Vue {
    constructor() {
        super(...arguments);
        this.showModal = false;
        this.resolvePromise = undefined;
        this.rejectPromise = undefined;
        this.title = "Please confirm";
    }
    mounted() {
        var app = getCurrentInstance();
        if (app) {
            app.appContext.config.globalProperties.$confirmModal = this;
        }
    }
    show(message, options) {
        var _a;
        this.message = message;
        this.title = (_a = options === null || options === void 0 ? void 0 : options.title) !== null && _a !== void 0 ? _a : this.title;
        this.showModal = true;
        return new Promise((resolve, reject) => {
            this.resolvePromise = resolve;
            this.rejectPromise = reject;
        });
    }
    ;
    handleHide(confirmed) {
        this.resolvePromise(confirmed);
        this.resolvePromise = undefined;
        this.showModal = false;
    }
    ;
    onHide(e) {
        if (this.resolvePromise) {
            this.resolvePromise(false);
        }
    }
    ;
};
ConfirmVue = __decorate([
    Component({
        name: "confirmVue",
        expose: ["show"]
    })
], ConfirmVue);
export default ConfirmVue;
